import React, { useRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Avatar, Grid, Typography} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Box,
  InputAdornment,
  Stack,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { getNewChatsUsingSearch, postingNewChatOrRetrivingOldChat } from "../../services";
import { useAppDispatch, useAppSelector } from "../../assets/hooks";
import { getFriends, setWordCase } from "../../assets/library";
import { Event, Participant, User } from "../../types/types";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { addChats } from "../../store/slices/chatsSlice";


interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const Transition = React.forwardRef(function Transition(
  props: any,
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const NewChatContainer: React.FC<Props> = ({ open, setOpen}) => {
  const [searchTerm, setSearchTerm] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [options,setOptions] = useState<User[]>([])
  const profile = useAppSelector(state =>state.profileInfo);
  const chats = useAppSelector(state =>state.chats);
  const allChats = [...chats.data.advisors,...chats.data.community]
  const friends = useRef(profile.data?._id ? getFriends(allChats,profile.data?._id) : []);
  const dispatch = useAppDispatch();

  const fetchNewChats = async (searchTerm:string) => {
    const response = await getNewChatsUsingSearch(searchTerm);
    if (response && response.data !== undefined) {
      setOptions(
        response?.data?.filter((item:any) => {
          return item._id !== profile.data?._id;
        })
      );
    } else {
      
    }
  };
  const getChatId = async (id:string) => {
    try{
      const response = await postingNewChatOrRetrivingOldChat(id);
      if (response && response.data !== undefined) {
      } else {
      }
      return response.data;
    }catch(error){

    }
  
};
const eventHandler = async (event:Event)=>{
  switch(event.name){
    case "handleChange":
      if (event.data.target.value !== "") {
        setSearchTerm(event.data.target.value);
        fetchNewChats(event.data.target.value.trim())
      }
    break;
    case "select":
      setLoading(true);
      setLoading(false);
      setOpen(false)
     const response1 = await getChatId(event.data._id)
      dispatch(addChats(response1))
  }
} 

  return (
    <div>
      <Dialog
        open={open}
        sx={{
            right: "0",
            left: { md: "45%", xs: "0", lg: "68%" },
            top: { md: "10px", xs: "0", lg: "25px" },
          }}
          PaperProps={{
            style: {
              borderRadius: "1rem",
              padding: "1rem",
              width: "410px",
              height: "550px",
            },
          }}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setOpen(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "300px",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <KeyboardArrowDownIcon
                onClick={() => setOpen(false)}
                sx={{ width: "2rem", height: "2rem" }}
              />
            </Box>
            <ChatsListContainer
              searchTerm={searchTerm}
              // handleSelect={handleSelect}
              eventHandler = {eventHandler}
              options={options}
              // handleChange={handleChange}
              friends={friends}
            />
          </>
        )}
      </Dialog>
    </div>
  );
};

interface ChatsListContainerProps {
  // handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  // handleSelect: (data: User) => void;
  eventHandler:any,
  options: User[];
  searchTerm: string | null;
  friends:any
}

const ChatsListContainer: React.FC<ChatsListContainerProps> = ({
  eventHandler,
  options,
  friends
}) => {
  return (
    <Stack spacing={1} className="chat-container-messenger1" sx={{ mt: 2, height: "480px" }}>
        <Typography textAlign="center" fontWeight="600">New Chat</Typography>
      <TextField
        size="small"
        fullWidth
        onChange={(e)=>eventHandler({name:"handleChange",data:e})}
        id="outlined-basic"
        placeholder="Search"
        variant="outlined"
        autoComplete="false"
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />

      <Box sx={{height:"420px",overflowY:"scroll",p:1}}>
        {options.map((item, index) => (
              <Grid container spacing={3} onClick={() =>eventHandler({name:"select",data:item})} sx={{p:0}}>
                <Grid
                  item
                  xs={2}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Avatar
                    src={item.displayPicSrc}
                    alt="profile"
                    style={{ width: "2rem", height: "2rem", borderRadius: "50%" }}
                  />
                </Grid>
                <Grid item xs={8} >
                  <h5>{setWordCase(item.firstName) + " " + setWordCase(item?.lastName)}</h5>
                </Grid>
                <Grid item xs={2}   sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}>
                  {friends.current?.find((friend: Participant) => friend._id === item._id) ? (
                    <span style={{color:"rgb(255, 117, 26)"}}>Friend</span>
                  ) : (
                    <PersonAddIcon sx={{ fontSize: "1.2rem", color: "teal" }} />

                  )}
                </Grid>
              </Grid>
        ))}
      </Box>
    </Stack>
  );
};

export default NewChatContainer;
